import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  useRedirect,
  useRefresh,
  CreateProps,
  BooleanInput,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import { GetParam } from "utils/tools";
import SanitizedGrid from "components/SanitizedGrid";
import { statusList } from "./util";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import CreateWrapper from "../../components/CreateWrapper";

const LevelCreate = (props: CreateProps) => {
  const redirect = useRedirect();
  const refresh = useRefresh();
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Levels", link: `/schools/${param.get("schoolId")}/show/1` },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = (props: { data: ILevel }) => {
    redirect(`/schools/${props.data.schoolId}/show/1`);
    refresh();
  };

  const transform = async (data: any) => {
    data.nextLevelId = null;

    return data;
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Level"
        transform={transform}
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <SelectInput
                source="status"
                choices={statusList}
                defaultValue="Active"
                validate={required()}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Drop Off Authorization</Typography>
            </Grid>
            <Grid item xs={4}>
              <BooleanInput
                label="Enable Drop Off Authorization"
                source="dropOffAuth"
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default LevelCreate;
